var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 5.5,
    fill: "#3578DB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 5.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 8.25C11.5074 8.25 10.5 9.25736 10.5 10.5V25.5C10.5 26.7426 11.5074 27.75 12.75 27.75H23.25C24.4926 27.75 25.5 26.7426 25.5 25.5V15.3107L18.4393 8.25H12.75ZM9 10.5C9 8.42893 10.6789 6.75 12.75 6.75H18.75C18.9489 6.75 19.1397 6.82902 19.2803 6.96967L26.7803 14.4697C26.921 14.6103 27 14.8011 27 15V25.5C27 27.5711 25.3211 29.25 23.25 29.25H12.75C10.6789 29.25 9 27.5711 9 25.5V10.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7629 6.80711C19.0432 6.69103 19.3658 6.75519 19.5803 6.96969L26.7803 14.1697C26.9948 14.3842 27.0589 14.7068 26.9428 14.987C26.8267 15.2673 26.5533 15.45 26.2499 15.45H22.6499C21.2584 15.45 20.092 15.2278 19.3071 14.4429C18.5222 13.6579 18.2999 12.4916 18.2999 11.1V7.50002C18.2999 7.19668 18.4827 6.9232 18.7629 6.80711ZM19.7999 9.31068V11.1C19.7999 12.4085 20.0277 13.0421 20.3678 13.3822C20.7078 13.7223 21.3415 13.95 22.6499 13.95H24.4393L19.7999 9.31068Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4961 24.0938L15.9609 19.1602H16.8633L16.6172 20.6367L15.1406 25.5H14.332L14.4961 24.0938ZM13.6348 19.1602L14.7773 24.1172L14.8711 25.5H13.9688L12.252 19.1602H13.6348ZM18.2344 24.0586L19.3418 19.1602H20.7188L19.0078 25.5H18.1055L18.2344 24.0586ZM17.0156 19.1602L18.4629 24.0352L18.6445 25.5H17.8359L16.3418 20.6309L16.0957 19.1602H17.0156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.bff32701eedf03b44374a01208d86c15.svg";
export { ForwardRef as ReactComponent };